// extracted by mini-css-extract-plugin
module.exports = {"slide-wrapper--first":"_9330de7794--slide-wrapper--first--ARKbd","slide-wrapper--last":"_9330de7794--slide-wrapper--last--ujeQ3"};